/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Product } from '../models/Product';
import type { ProductCondition } from '../models/ProductCondition';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProductService {
    /**
     * Add a product
     * @param workspaceId Workspace ID required
     * @param requestBody
     * @returns any Successfully added a product
     * @throws ApiError
     */
    public static postProduct(
        workspaceId: string,
        requestBody: {
            name: string;
            product_conditions: Array<ProductCondition>;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/product',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `An error occcured`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Deletes a product
     * @param id The id of product to delete
     * @param workspaceId Workspace ID is required in every request
     * @returns any Successfully deleted product
     * @throws ApiError
     */
    public static deleteProduct(
        id: string,
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/product/{id}',
            path: {
                'id': id,
            },
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                404: `Product not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List of products
     * @param workspaceId The workspace_id of product to get or delete
     * @param limit Limit of objects to get
     * @param offset skip number of objects to get in list
     * @returns any Successfully retrieved product list
     * @throws ApiError
     */
    public static getProductList(
        workspaceId: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<{
        items?: Array<Product>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/product/list',
            query: {
                'workspace_id': workspaceId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                404: `No product found`,
                500: `Internal server error`,
            },
        });
    }
}
